var React = require('react');
const costMappings = JSON.parse(document.getElementById('cost-mappings').getAttribute('data_value'));

class CannabisAccordion extends React.Component {

    constructor() {
        super();
        this.state = {
            open: false
        }
        this.onClick = this.onClick.bind(this);
        this.contents = this.contents.bind(this);
        this.checkboxClick = this.checkboxClick.bind(this);
    }

    onClick(e) {
        this.props.actions.clickAccordion(this.props.index, e.target.checked)
        this.setState({open: !this.state.open})
    }

    checkboxClick(inputName, e) {
        this.props.actions.checkInput(this.props.index, inputName, e.target.checked)
    }

    contents() {
        if (this.state.open) {
            return (
                <div className='accordion-contents'>
                    <div>
                        <input
                            className="user-checkbox big-checkbox"
                            id="cannabis__cbd_thc_potency"
                            value="cannabis__cbd_thc_potency"
                            type="checkbox"
                            name={`option-${this.props.index}[]`}
                            onClick={(e) => {
                                this.checkboxClick('cannabis__cbd_thc_potency', e);
                            }}
                        />
                        <span className="option-label">CBD/THC Potency (${costMappings['cannabis__cbd_thc_potency']})</span>
                    </div>
                    <div>
                        <input
                            className="user-checkbox big-checkbox"
                            id="cannabis__cbd_thc_potency_plus"
                            value="cannabis__cbd_thc_potency_plus"
                            type="checkbox"
                            name={`option-${this.props.index}[]`}
                            onClick={(e) => {
                                this.checkboxClick('cannabis__cbd_thc_potency_plus', e);
                            }}
                        />
                        <span className="option-label">CBD/THC Potency+ (${costMappings['cannabis__cbd_thc_potency_plus']})</span>
                    </div>
                    <div>
                        <input
                            className="user-checkbox big-checkbox"
                            id="cannabis__cbd_thc_potency_plus_plus"
                            value="cannabis__cbd_thc_potency_plus_plus"
                            type="checkbox"
                            name={`option-${this.props.index}[]`}
                            onClick={(e) => {
                                this.checkboxClick('cannabis__cbd_thc_potency_plus_plus', e);
                            }}
                        />
                        <span className="option-label">CBD/THC Potency++ (${costMappings['cannabis__cbd_thc_potency_plus_plus']})</span>
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div className="accordion cannabis">
                <div onClick={this.onClick}>
                    <input type='checkbox' className="user-checkbox big-checkbox" checked={this.state.open} />
                    <span className='option-label'>Cannabis <small><i> - (Click/tap to see options)</i></small>
                    </span>
                </div>
                {this.contents()}
            </div>
        );
    }
}

export default CannabisAccordion
